import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { api } from 'utils/axios';
import Cookies from 'js-cookie';

const initialState = {
  firstName: '',
  lastName: '',
  phone: '',
  email: '',
  address: {
    full: '',
    state: '',
    city: '',
    streetByGoogle: '',
    zip: '',
    streetByClient: '',
  },
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  comment: '',
  customerType: 'DTC',
  loading: false,
  lead_id: null,
  opportunity_id: null,
  account_id: null,
  contact_id: null,
  sr_id: null,
  is_portal_link: null,
  areaStatus: true,
  gclid: Cookies.get('gclid'),
};

export const sendForm = createAsyncThunk(
  'sendForm',
  async (args, { rejectWithValue, getState }) => {
    try {
      const { form, global } = getState();
      const formData = new FormData();

      formData.append('firstName', form.firstName);
      formData.append('lastName', form.lastName);
      formData.append('phone', form.phone);
      formData.append('email', form.email);
      formData.append('state', form.address.state);
      formData.append('city', form.address.city);
      formData.append('zip', form.address.zip);
      formData.append('streetByGoogle', form.address.streetByGoogle);
      formData.append('streetByCustomer', form.address.streetByClient);
      formData.append('millage', global.resDjangoGoogleApi.data.distanceMiles);
      formData.append(
        'insuranceFront',
        args.insuranceFront ? args.insuranceFront.files[0] : null
      );
      formData.append(
        'insuranceBack',
        args.insuranceBack ? args.insuranceBack.files[0] : null
      );
      if (args.labOrders) {
        args.labOrders.files.forEach((item) => {
          formData.append('labOrders', item);
        });
      } else {
        formData.append('labOrders', null);
      }
      formData.append('date1', args.date1 ? args.date1.getTime() : null);
      formData.append('date2', args.date2 ? args.date2.getTime() : null);
      formData.append('date3', args.date3 ? args.date3.getTime() : null);
      formData.append('timezone', form.timezone);
      formData.append('noteByCustomer', form.comment);
      formData.append('salesForce', global.configs.salesforce_status);
      formData.append('lead_id', form.lead_id);
      formData.append('opportunity_id', form.opportunity_id);
      formData.append('account_id', form.account_id);
      formData.append('contact_id', form.contact_id);
      formData.append('customerType', form.customerType);

      const response = await api.post('/submit_react_form/', formData);
      console.log(response);

      localStorage.setItem('sr_id', response.data.sr_id);

      const formDataEnd = new FormData();
      let gclid = '';
      if (Cookies.get('gclid') !== null) gclid = Cookies.get('gclid');

      formDataEnd.append('fname', form.firstName);
      formDataEnd.append('lname', form.lastName);
      formDataEnd.append('opportunityOid', form.opportunity_id);
      formDataEnd.append('stageName', 'Closed Won');
      formDataEnd.append('googleClid', gclid);
      formDataEnd.append('user_messagebyuser', 'React Form');
      formDataEnd.append('user_rootchoice', 'Submit SR - DTC');
      formDataEnd.append('email', form.email);
      formDataEnd.append('locationStreet', form.address.streetByGoogle);
      formDataEnd.append('locationCity', form.address.city);
      formDataEnd.append('locationState', form.address.state);
      formDataEnd.append('locationZip', form.address.zip);
      formDataEnd.append(
        'user_distance',
        global.resDjangoGoogleApi.data.distanceMiles
      );
      formDataEnd.append('amount', global.resDjangoGoogleApi.data.cost);

      await api.post(
        'https://hook.us1.make.com/fokwmv6y2nsi94yptm7u4375tutedxyi',
        formDataEnd
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendContactInfo = createAsyncThunk(
  'sendContactInfo',
  async (args, { rejectWithValue, getState }) => {
    const { form, global } = getState();
    const formData = new FormData();
    formData.append('type', 'React Form');
    formData.append('signature', process.env.REACT_APP_SIGNATURE);
    formData.append('first_name', form.firstName);
    formData.append('last_name', form.lastName);
    formData.append('phone', form.phone);
    formData.append('email', form.email);
    formData.append(
      'address',
      JSON.stringify({
        state: form.address.state,
        city: form.address.city,
        streetOne: form.address.streetByGoogle,
        streetTwo: form.address.streetByClient,
        zip: form.address.zip,
      })
    );
    formData.append('millage', global.resDjangoGoogleApi.data.distanceMiles);
    formData.append('customerType', form.customerType);
    formData.append('gclid', Cookies.get('gclid'));

    try {
      const response = await api.post('/contact_info/', formData);

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendZapier = createAsyncThunk(
  'sendZapier',
  async (args, { rejectWithValue, getState }) => {
    const { form } = getState();
    const formData = new FormData();
    formData.append('firstName', form.firstName);
    formData.append('lastName', form.lastName);
    formData.append('phone', form.phone);
    formData.append('email', form.email);
    formData.append('address', form.address.full);
    formData.append('customerType', form.customerType);

    try {
      const response = await axios.post(
        'https://hooks.zapier.com/hooks/catch/2616746/bhh3x7a/',
        formData
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sendZapierDjango = createAsyncThunk(
  'sendZapierDjango',
  async (args, { rejectWithValue, getState }) => {
    const { form } = getState();
    const formData = new FormData();
    formData.append('first_name', form.firstName);
    formData.append('last_name', form.lastName);
    formData.append('phone', form.phone);
    formData.append('email', form.email);
    formData.append('address', form.address.full);
    formData.append('customerType', form.customerType);

    try {
      const response = await api.post(
        '/create_salesforce_opportunity/',
        formData
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const formSlice = createSlice({
  name: 'FormSlice',
  initialState,
  reducers: {
    fillDataWithQuery(state, { payload }) {
      const availableQueries = [
        'first_name',
        'last_name',
        'mobile_number',
        'email',
        'sr_id',
        'customer_type',
      ];
      Object.keys(payload).forEach((key) => {
        if (availableQueries.includes(key)) {
          switch (key) {
            case 'first_name':
              state.firstName = payload[key];
              break;
            case 'last_name':
              state.lastName = payload[key];
              break;
            case 'mobile_number':
              state.phone = payload[key];
              break;
            case 'email':
              state.email = payload[key];
              break;
            case 'sr_id':
              state.sr_id = payload[key];
              break;
            case 'customer_type':
              state.customerType = payload[key];
              break;
            default:
              break;
          }
          // if (key === 'first_name') state.firstName = payload[key];
          // else if (key === 'last_name') state.lastName = payload[key];
          // else if (key === 'mobile_number') state.phone = payload[key];
          // else if (key === 'email') state.email = payload[key];
          // else if (key === 'sr_id') state.email = payload[key];
          // else if (key === 'customer_type') state.customerType = payload[key];
        }
      });
    },
    fillStep1Data(state, { payload }) {
      state.firstName = payload.firstName;
      state.lastName = payload.lastName;
    },
    fillStep2Data(state, { payload }) {
      state.phone = payload.phone;
    },
    fillStep3Data(state, { payload }) {
      state.email = payload.email;
    },
    fillStep4Data(state, { payload }) {
      state.address.full = payload.address;
      state.address.state = payload.addressObj.state
        ? payload.addressObj.state
        : null;
      state.address.city = payload.addressObj.city
        ? payload.addressObj.city
        : null;
      state.address.zip = payload.addressObj.zip
        ? payload.addressObj.zip
        : null;
      state.address.streetByGoogle = payload.addressObj.street1
        ? payload.addressObj.street1
        : null;
    },
    fillStep5Data(state, { payload }) {
      state.address.streetByClient = payload.altStreet;
    },
    fillStep8Data(state, { payload }) {
      state.comment = payload.comment;
    },
    updateStatusOfArea(state, { payload }) {
      state.areaStatus = payload.areaStatus;
    },
  },

  extraReducers: (builder) => {
    builder

      // Send Form //
      .addCase('sendForm/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendForm/fulfilled', (state, { payload }) => {
        state.loading = false;
        state.sr_id = payload.sr_id;
        state.is_portal_link = payload.is_portal_link || '/';
      })
      .addCase('sendForm/rejected', (state, { payload }) => {
        state.loading = false;
        state.is_portal_link = payload.is_portal_link || '/';
        console.error(payload, 'Error Responce FORM');
      })
      // Send Zapier (ADDRESS NOT FOUND CONDITION)//
      .addCase('sendZapier/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendZapier/fulfilled', (state) => {
        state.loading = false;
      })
      .addCase('sendZapier/rejected', (state) => {
        state.loading = false;
      })
      // Send Zapier Django (ADDRESS NOT FOUND CONDITION)//
      .addCase('sendZapierDjango/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendZapierDjango/fulfilled', (state) => {
        state.loading = false;
      })
      .addCase('sendZapierDjango/rejected', (state) => {
        state.loading = false;
      })

      // Send Contact Info //
      .addCase('sendContactInfo/pending', (state) => {
        state.loading = true;
      })
      .addCase('sendContactInfo/fulfilled', (state, { payload }) => {
        state.loading = false;
        state.lead_id = payload.react_form.lead_id
          ? payload.react_form.lead_id
          : null;
        state.opportunity_id = payload.react_form.opportunity_id
          ? payload.react_form.opportunity_id
          : null;
        state.contact_id = payload.react_form.contact_id
          ? payload.react_form.contact_id
          : null;
        state.account_id = payload.react_form.account_id
          ? payload.react_form.account_id
          : null;
      })
      .addCase('sendContactInfo/rejected', (state, { payload }) => {
        state.loading = false;
        console.log(payload, 'Error Responce CONTACT_INFO');
      });
  },
});

export const {
  fillDataWithQuery,
  fillStep1Data,
  fillStep2Data,
  fillStep3Data,
  fillStep4Data,
  fillStep5Data,
  fillStep8Data,
  updateStatusOfArea,
} = formSlice.actions;

export default formSlice.reducer;
